import * as React from 'react';
import './App.scss';
import Mipa from './components/Mipa';

import { Route,BrowserRouter,Routes } from "react-router-dom";
import * as microsoftTeams from "@microsoft/teams-js";
//const logo = require('./logo.svg');
//https://stackoverflow.com/questions/37295377/how-to-navigate-from-one-page-to-another-in-react-js
class App extends React.Component<{}, {}> {
  render() {
    microsoftTeams.app.initialize();
    return (
      <div className="App1">
         <BrowserRouter>
                    
                      <Routes>
                        <Route path="/"  element={
                           <Mipa isUsers={false} isSetting={false} email='' name='' isteam={true} culturename='en-US'/>

                        } />
                        <Route path="/teammipa"  element={
                           <Mipa isUsers={false} isSetting={false} email='' name='' isteam={true} culturename='en-US'/>

                        } />
                    <Route path="/setting" element={
                           <Mipa isUsers={false} isSetting={true} email='' name='' isteam={true} culturename='en-US'/>

                        }/>
                        <Route path="/teammipa/setting" element={
                           <Mipa isUsers={false} isSetting={true} email='' name='' isteam={true} culturename='en-US'/>

                        }/>
                         <Route path="/users" element={
                           <Mipa isUsers={true} isSetting={false} email='' name='' isteam={true} culturename='en-US'/>

                        }/>
                         <Route path="/teammipa/users" element={
                           <Mipa isUsers={true} isSetting={false} email='' name='' isteam={true} culturename='en-US'/>

                        }/>
                        
                      </Routes>                    
                   
                </BrowserRouter>
     
       {/*  
        <Router history={history} >
        <div className="root">
          <Switch>
            <Route path="/" component={MainPage} exact />
            <Route path="/dashboard" component={DashBoard} exact />
            <Route path="/docs" component={Docs} exact />
            <Route component={ErrorPage} />
          </Switch>

        </div>
      </Router >
       <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Welcome to React</h2>
        </div>
        <p className="App-intro">
          To get started, edit <code>src/App.tsx</code> and save to reload.
          <div className="test">Samareshs</div>
        </p> */}
        
      </div>
    );
  }
}

export default App;
